var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "averagePayment" }, [
    _c(
      "div",
      { staticClass: "recipientAvgPayment" },
      [
        _c("el-progress", {
          attrs: {
            "text-inside": true,
            "stroke-width": 26,
            percentage: _vm.percentage,
            color: _vm.determinedColor
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "text-color--gray fs-13" }, [
      _c("div", { staticClass: "p-5" }, [
        _vm._v(
          "\n\t\t\t" +
            _vm._s(_vm.$t("RecipientDetail.payment_action_text")) +
            "\n\t\t"
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          "\n\t\t\t" +
            _vm._s(_vm.$t("RecipientDetail.avg_payment_unavailable_text")) +
            "\n\t\t"
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }